export const RESET = 'RESET';
export const CREDENTIALS = 'CREDENTIALS';
export const LANGUAGE = 'LANGUAGE';
export const UPDATE_AUTH = 'UPDATE_AUTH';
export const UPDATE_CUSTOMER_ID = 'UPDATE_CUSTOMER_ID';
export const SELECT_STORE = 'SELECT_STORE';
